import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import config from './RootConfig';
import constants from '../constants';

var $ = require('jquery');

const divs = [];

export default class PrivacyPage extends Component {

    constructor(props) {
        super(props);

        this.state = { divs: divs };
    }

    componentDidMount() {
        //console.log('componentDidMount...');

        window.scrollTo(0, 0);
    }

    render() {
        //console.log('render...');
        let pagecontent;

	if (window.location.hostname.indexOf(config.NJG) != -1) {
		pagecontent = (
<div id="privacy" class="box-full">
<h1>隱私權聲明</h1>

<h3 style={{ "paddingTop" : "0px" }}>1. 簡介</h3>
<p>歡迎閱讀 njg 的隱私權保護規則。您的隱私對 njg 非常重要。您在使用 njg 之前必須閱讀並同意本隱私權保護規則的條款。</p>
<p>為了讓 njg 的服務可以正常運作，njg 會收集、使用並（在一些情況下）向第三方披露有關您的資料。本隱私權保護規則制約 njg 收集的有關您的資料及您對 njg 提供給您的資料之使用。無論您是否已經成為 njg 的註冊用戶，您以任何方>式使用 njg 服務的行為，均表示您接受本隱私權保護規則及用戶協定，即為明示同意 njg 按本隱私權保護規則所述方式使用和披露您的個人資料。如您自行選擇註冊為 njg 用戶，則本隱私權保護規則被納入 njg 用戶協議之中，並受該協議的條款
制約。</p>

<h3 style={{ "paddingTop" : "0px" }}>2. njg 收集的資料</h3>
<p>您的資料包括您在 njg 網站登記的個人及帳號資料，也包括您在 njg 內的其他網頁上公佈的任何內容。</p>
<p>我們收集和儲存的個人資料包括下列方面的內容：</p>
<p>當您使用 njg 的服務時，我們會收集您的應用程式、瀏覽器和裝置等相關資訊。這些資訊包括瀏覽器類型和設定、裝置類型和設定、作業系統、行動網路資訊。也可能包括您剛來自何路徑（不論該路徑是否在 njg 的網站）、您接下 來進入哪一個路
徑（不論該路徑是否在 njg 的網站），您的流覽器向 njg 發送的資料，以及您的 IP 地址等。</p>
<p>如您注冊成為 njg 的用戶，我們會收集您的電郵地址以作登入之用，還可能收集一些您自願提供的資料，包括生日日期、職業、性別等。如果您選擇在 njg 的網站進行發佈、管理資訊， njg 收集關於您的發佈、管理資訊行為的資料。如果您選擇
在 njg 登錄資訊或給其他用戶留下資訊， njg 將會收集並存儲您向 njg 提供的、 njg 為達到上述主要目標所必須的資料。
如您成為了我們的星級編輯，我們還會收集您的真實姓名、通訊地址及／或付款資訊等以作支付稿費之用。</p>
<p>njg 運用多種技術來收集及儲存資訊，包括 Cookie、像素廣告代碼等。Cookie 是 njg 網站放在您電腦中的小型文字檔，用以記錄一些不含個人識別資訊（例如姓名、電話）的資料，協助我們讓您使用網站時可以獲得更好的體驗。</p>
<p>njg 目前便用的 Cookie主要分為以下類型：</p>
<p>(i) 用以提供 njg 網站主要功能的 Cookie，例如
</p><ul>
<li>- 我們使用 Cookie 來記錄注冊用戶的登入資訊，使用戶在一個時間段內無需重複登入帳戶;</li>
<li>- 記下用戶的瀏覽偏好，例如網站展示方式；</li>
<li>- 記住用戶曾經收到的通知，並且不再顯示這些通知;</li>
</ul><p></p>
<p>(ii) 用以改善 njg 網站效能的 Cookie。我們使用 Google Analytics 來收集用戶使用 njg 的資訊（例如讀者在網頁頁面的停留時間，最多人使用什麼裝置瀏覽 njg），讓我們能夠繼續提供更好的網站服務。而 Google Analytics 會使用其專用>的 Cookie 來收集這些資訊。</p>
<p>(iii) 用以展示廣告的 Cookie。njg 以及其廣告合作伙伴可能使用廣告 Cookie 來提供我們認為與您相關且您會感興趣的廣告。廣告 Cookie 還可以用作限制您在 njg 上看到相同廣告的次數，以及協助衡量廣告行銷活動的成效。</p>
<p>如果您的流覽器允許，您可以拒絶 njg 的 Cookie，但您可能因此不能使用 njg 提供的某些功能。</p>

<h3 style={{ "paddingTop" : "0px" }}>3. njg 對您的資料的使用</h3>
<p>您同意 njg 可使用關於您的個人資料（包括但不限於 njg 持有的有關您的檔案中的資料，及 njg 自您目前及以前在網站上的活動所獲取的其他資料）以便：</p>
<p></p><ul>
<li>- 提供我們的服務，例如以電郵及密碼登入系統</li>
<li>- 設計個性化用戶體驗、衡量用戶對我們服務的感興趣程度以及通知用戶我們的服務和更新</li>
<li>- 向您發送我們的合作夥伴之服務及/或產品的宣傳及/或推廣資訊</li>
<li>- 進行其他我們在收集資料時候表述過的工作</li>
</ul><p></p>

<h3 style={{ "paddingTop" : "0px" }}>4. njg 對您的資料的披露</h3>
<p>您在 njg 上發佈的內容，包括在網站上發佈的文章、留言或個人介紹等資訊，是明顯地可以為公眾 所獲取的公開信息。一旦您公開分享這些資訊，其他人就有可能透過搜尋引擎存取您的內容。</p>
<p>njg 可將不含身分識別內容的資訊提供給合作夥伴 (例如廣告客戶)。我們也允許特定合作夥伴使用自己的 Cookie 或類似技術，從您的瀏覽器或裝置收集資訊，以便放送廣告及評估各項數據。</p>
<p>njg 不會與第三方（例如廣告客戶）分享您的個人識別資訊 (例如您的姓名或電子郵件)，除非以下的情況：</p>
<p></p><ul>
<li>- 我們得到您的同意；</li>
<li>- 配合任何適用法律、法規、法律令狀或合法的政府請求。njg 就全球執法機構及其他第三方為了執行法律、知識產權及其他權利而提出的調查提供合作。 njg 可以（而且您授權 njg ）向全球執法機關或其他政府官員披露 njg 全權酌情決定>認為就調查某項欺詐案、知識產權侵權、盜版或其他非法或可能使 njg 須承擔法律責任的活動而必要、適當或適用的香港特別行政區、其他國家和地區和國際法律法規下另行允許的任何關於您的資料。此外， njg 可以（而且您通過成為 njg 用戶而>授權 njg ）按 njg 全權酌情決定認為就調查可能會使 njg 負上法律責任的欺詐案、知識產權侵權、盜版或其他活動屬於必要或適當或適用的香港特別行政區法律法規下另行允許的向 njg 認證權利所有人方案參與者和/或認證知識產權所有人的參>與者披露您的用戶識別號碼、姓名、電話號碼、電郵地址等資料。</li>
</ul><p></p>

<h3 style={{ "paddingTop" : "0px" }}>5. 保護您的密碼</h3>
<p>您須對使用您的註冊電郵地址和密碼所採取的一切行動負責。因此， njg 建議您不要向任何第三方披露您的 njg 密碼。如果您選擇與第三方共用您的註冊電郵地址或您的資料以獲得額外服務，則您同意對您使用您的註冊電郵地址 和密碼所採取的一
切行動負責，而且您須審閱該第三方的隱私權保護規則。如果您對您的密碼失去控制，您可能對您的個人資料失去實質性的控制，並可能因他人以您的名義採取的有法律約束力的行動而受到制約或承擔責任。因此，如果您的密碼因任何原因而受到危害，您須
立即更改您的密碼。</p>

<h3 style={{ "paddingTop" : "0px" }}>6. 取用、審核、更改或刪除您的個人身份識別資料</h3>
<p>您可以在註冊後更改您在進行註冊時所提交的資料，包括但不限於：</p>
<p></p><ul>
<li>- 您的密碼；</li>
<li>- 自我介紹；</li>
<li>- 職業、收入等自願提供的資料。</li>
</ul><p></p>
<p>您可以通過查閱您的發佈資訊或者個人帳戶資訊頁面來閱讀、修改或者刪除您的個人資訊；也可以通過和客戶服務部門聯繫來查閱由我們儲存但是在 njg 上面沒有的任何您的個人資訊。</p>
<p>您可以與我們聯繫並要求刪除您的個人資料，我們會在接收到要求後盡快處理。njg 將在 njg 的檔案中保留您在某些情況下要求刪除的部份資料，以防止欺詐、為了解決爭議、對糾紛進行調停、協助進行任何調查、防止不良分子再次使用我們的服務
和執行 njg 的用戶協議，以及遵守法律要求。此外，由於 njg 在多個系統進行備份，上述要求刪除的資料仍可能存放於備份中一段時間，直至備份失效（一般不會儲存超過3個月）。</p>

<h3 style={{ "paddingTop" :" 0px" }}>7. 其他資料收集者</h3>
<p>除本隱私權保護規則中另行明示討論者外，本隱私權聲明只涉及對 njg 從您收集得來的資料的使用和披露。在您將您的資料披露給其他方（不論它們是本網站或互聯網上的其他網站經營者或用戶、發佈者或閱讀者）的範圍內，它們對您所披露的個人資
料的使用或披露可能適用不同的規則。如果 njg 使用第三方廣告商，他們應遵守他們自己的隱私慣例和規則。</p>
<p>另外，搜索引擎（如 www.google.com，www.yahoo.com等）可能會對您發佈的資訊進行存檔或以其他的方式進行保存。由於 njg 並不控制第三方的隱私權保護規則，因此您須受該第三方的隱私權保護規則的約束。 njg 建議您在向他人披露您的個人>資料之前作出查詢。</p>
</div>
		)
	}
	else {
		pagecontent = (
<div id="privacy" class="box-full">
<h1>隱私權聲明</h1>

<h3 style={{ "paddingTop" : "0px" }}>1. 簡介</h3>
<p>歡迎閱讀 minibean 的隱私權保護規則。您的隱私對 minibean 非常重要。您在使用 minibean 之前必須閱讀並同意本隱私權保護規則的條款。</p>
<p>為了讓 minibean 的服務可以正常運作，minibean 會收集、使用並（在一些情況下）向第三方披露有關您的資料。本隱私權保護規則制約 minibean 收集的有關您的資料及您對 minibean 提供給您的資料之使用。無論您是否已經成為 minibean 的註冊用戶，您以任何方>式使用 minibean 服務的行為，均表示您接受本隱私權保護規則及用戶協定，即為明示同意 minibean 按本隱私權保護規則所述方式使用和披露您的個人資料。如您自行選擇註冊為 minibean 用戶，則本隱私權保護規則被納入 minibean 用戶協議之中，並受該協議的條款
制約。</p>

<h3 style={{ "paddingTop" : "0px" }}>2. minibean 收集的資料</h3>
<p>您的資料包括您在 minibean 網站登記的個人及帳號資料，也包括您在 minibean 內的其他網頁上公佈的任何內容。</p>
<p>我們收集和儲存的個人資料包括下列方面的內容：</p>
<p>當您使用 minibean 的服務時，我們會收集您的應用程式、瀏覽器和裝置等相關資訊。這些資訊包括瀏覽器類型和設定、裝置類型和設定、作業系統、行動網路資訊。也可能包括您剛來自何路徑（不論該路徑是否在 minibean 的網站）、您接下 來進入哪一個路
徑（不論該路徑是否在 minibean 的網站），您的流覽器向 minibean 發送的資料，以及您的 IP 地址等。</p>
<p>如您注冊成為 minibean 的用戶，我們會收集您的電郵地址以作登入之用，還可能收集一些您自願提供的資料，包括生日日期、職業、性別等。如果您選擇在 minibean 的網站進行發佈、管理資訊， minibean 收集關於您的發佈、管理資訊行為的資料。如果您選擇
在 minibean 登錄資訊或給其他用戶留下資訊， minibean 將會收集並存儲您向 minibean 提供的、 minibean 為達到上述主要目標所必須的資料。
如您成為了我們的星級編輯，我們還會收集您的真實姓名、通訊地址及／或付款資訊等以作支付稿費之用。</p>
<p>minibean 運用多種技術來收集及儲存資訊，包括 Cookie、像素廣告代碼等。Cookie 是 minibean 網站放在您電腦中的小型文字檔，用以記錄一些不含個人識別資訊（例如姓名、電話）的資料，協助我們讓您使用網站時可以獲得更好的體驗。</p>
<p>minibean 目前便用的 Cookie主要分為以下類型：</p>
<p>(i) 用以提供 minibean 網站主要功能的 Cookie，例如
</p><ul>
<li>- 我們使用 Cookie 來記錄注冊用戶的登入資訊，使用戶在一個時間段內無需重複登入帳戶;</li>
<li>- 記下用戶的瀏覽偏好，例如網站展示方式；</li>
<li>- 記住用戶曾經收到的通知，並且不再顯示這些通知;</li>
</ul><p></p>
<p>(ii) 用以改善 minibean 網站效能的 Cookie。我們使用 Google Analytics 來收集用戶使用 minibean 的資訊（例如讀者在網頁頁面的停留時間，最多人使用什麼裝置瀏覽 minibean），讓我們能夠繼續提供更好的網站服務。而 Google Analytics 會使用其專用>的 Cookie 來收集這些資訊。</p>
<p>(iii) 用以展示廣告的 Cookie。minibean 以及其廣告合作伙伴可能使用廣告 Cookie 來提供我們認為與您相關且您會感興趣的廣告。廣告 Cookie 還可以用作限制您在 minibean 上看到相同廣告的次數，以及協助衡量廣告行銷活動的成效。</p>
<p>如果您的流覽器允許，您可以拒絶 minibean 的 Cookie，但您可能因此不能使用 minibean 提供的某些功能。</p>

<h3 style={{ "paddingTop" : "0px" }}>3. minibean 對您的資料的使用</h3>
<p>您同意 minibean 可使用關於您的個人資料（包括但不限於 minibean 持有的有關您的檔案中的資料，及 minibean 自您目前及以前在網站上的活動所獲取的其他資料）以便：</p>
<p></p><ul>
<li>- 提供我們的服務，例如以電郵及密碼登入系統</li>
<li>- 設計個性化用戶體驗、衡量用戶對我們服務的感興趣程度以及通知用戶我們的服務和更新</li>
<li>- 向您發送我們的合作夥伴之服務及/或產品的宣傳及/或推廣資訊</li>
<li>- 進行其他我們在收集資料時候表述過的工作</li>
</ul><p></p>

<h3 style={{ "paddingTop" : "0px" }}>4. minibean 對您的資料的披露</h3>
<p>您在 minibean 上發佈的內容，包括在網站上發佈的文章、留言或個人介紹等資訊，是明顯地可以為公眾 所獲取的公開信息。一旦您公開分享這些資訊，其他人就有可能透過搜尋引擎存取您的內容。</p>
<p>minibean 可將不含身分識別內容的資訊提供給合作夥伴 (例如廣告客戶)。我們也允許特定合作夥伴使用自己的 Cookie 或類似技術，從您的瀏覽器或裝置收集資訊，以便放送廣告及評估各項數據。</p>
<p>minibean 不會與第三方（例如廣告客戶）分享您的個人識別資訊 (例如您的姓名或電子郵件)，除非以下的情況：</p>
<p></p><ul>
<li>- 我們得到您的同意；</li>
<li>- 配合任何適用法律、法規、法律令狀或合法的政府請求。minibean 就全球執法機構及其他第三方為了執行法律、知識產權及其他權利而提出的調查提供合作。 minibean 可以（而且您授權 minibean ）向全球執法機關或其他政府官員披露 minibean 全權酌情決定>認為就調查某項欺詐案、知識產權侵權、盜版或其他非法或可能使 minibean 須承擔法律責任的活動而必要、適當或適用的香港特別行政區、其他國家和地區和國際法律法規下另行允許的任何關於您的資料。此外， minibean 可以（而且您通過成為 minibean 用戶而>授權 minibean ）按 minibean 全權酌情決定認為就調查可能會使 minibean 負上法律責任的欺詐案、知識產權侵權、盜版或其他活動屬於必要或適當或適用的香港特別行政區法律法規下另行允許的向 minibean 認證權利所有人方案參與者和/或認證知識產權所有人的參>與者披露您的用戶識別號碼、姓名、電話號碼、電郵地址等資料。</li>
</ul><p></p>

<h3 style={{ "paddingTop" : "0px" }}>5. 保護您的密碼</h3>
<p>您須對使用您的註冊電郵地址和密碼所採取的一切行動負責。因此， minibean 建議您不要向任何第三方披露您的 minibean 密碼。如果您選擇與第三方共用您的註冊電郵地址或您的資料以獲得額外服務，則您同意對您使用您的註冊電郵地址 和密碼所採取的一
切行動負責，而且您須審閱該第三方的隱私權保護規則。如果您對您的密碼失去控制，您可能對您的個人資料失去實質性的控制，並可能因他人以您的名義採取的有法律約束力的行動而受到制約或承擔責任。因此，如果您的密碼因任何原因而受到危害，您須
立即更改您的密碼。</p>

<h3 style={{ "paddingTop" : "0px" }}>6. 取用、審核、更改或刪除您的個人身份識別資料</h3>
<p>您可以在註冊後更改您在進行註冊時所提交的資料，包括但不限於：</p>
<p></p><ul>
<li>- 您的密碼；</li>
<li>- 自我介紹；</li>
<li>- 職業、收入等自願提供的資料。</li>
</ul><p></p>
<p>您可以通過查閱您的發佈資訊或者個人帳戶資訊頁面來閱讀、修改或者刪除您的個人資訊；也可以通過和客戶服務部門聯繫來查閱由我們儲存但是在 minibean 上面沒有的任何您的個人資訊。</p>
<p>您可以與我們聯繫並要求刪除您的個人資料，我們會在接收到要求後盡快處理。minibean 將在 minibean 的檔案中保留您在某些情況下要求刪除的部份資料，以防止欺詐、為了解決爭議、對糾紛進行調停、協助進行任何調查、防止不良分子再次使用我們的服務
和執行 minibean 的用戶協議，以及遵守法律要求。此外，由於 minibean 在多個系統進行備份，上述要求刪除的資料仍可能存放於備份中一段時間，直至備份失效（一般不會儲存超過3個月）。</p>

<h3 style={{ "paddingTop" : "0px" }}>7. 其他資料收集者</h3>
<p>除本隱私權保護規則中另行明示討論者外，本隱私權聲明只涉及對 minibean 從您收集得來的資料的使用和披露。在您將您的資料披露給其他方（不論它們是本網站或互聯網上的其他網站經營者或用戶、發佈者或閱讀者）的範圍內，它們對您所披露的個人資
料的使用或披露可能適用不同的規則。如果 minibean 使用第三方廣告商，他們應遵守他們自己的隱私慣例和規則。</p>
<p>另外，搜索引擎（如 www.google.com，www.yahoo.com等）可能會對您發佈的資訊進行存檔或以其他的方式進行保存。由於 minibean 並不控制第三方的隱私權保護規則，因此您須受該第三方的隱私權保護規則的約束。 minibean 建議您在向他人披露您的個人>資料之前作出查詢。</p>
</div>
		)
	}
	return (
            <div style={{ "marginTop": "50px" }}>
                <div className="col-md-1">
                </div>
                <div className="col-md-10">
                    <div className="themeA-container">
                        <div className="row">
                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                <div className="general-box" style={{ "minHeight": "300px" }}>
					{pagecontent}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                {/*
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-1">
                </div>
            </div >
        )
    }
}





// WEBPACK FOOTER //
// ./src/containers/PrivacyPage.js